export class FinancialProtectionMessageModel {
    financialProtectionMessageId: string;
    financialProtectionMessage: string;
    status: boolean;
    constructor() {
        this.financialProtectionMessageId="";
        this.financialProtectionMessage="";
        this.status=false;
    }
}